import { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { submit, SubmissionError } from 'redux-form';
import { useTranslation } from 'react-i18next';
import { useLocation, useHistory } from 'react-router-dom';
import moment from 'moment';

import { path } from 'router/sections';
import { user, data } from 'services';
import { cloneDeep, notify } from 'libs/common';
import { archiveTariff, getTariffTemplates, getTariff, updateTariff } from 'services/tariffs-service';
import { Confirm, Card, DataWrapper, PageWrapper, Headline, CloseCardButton, Button, themes, TableExt } from 'libs/ui';
import { useEscape } from 'hooks';
import { getTarrificatorByPath, getCategories, getVehicleClasses, tariffTypes } from 'services/types';
import {
  HeaderBlock,
  Name,
  OtherInfo,
  Status,
  StatusBlock,
  // StyledTariffsGrid,
  TariffGeneralInfo,
  TransportClass,
  NameTarifficator,
  TariffManageWrapper,
} from './tariff-card.styled';
import TariffForm from './forms/tariff-form-old';
import { TarifficatorSelector } from './blocks/tarifficator-selector';
import { getTableParams } from 'grids/tariff/grid.params';

import { dataFields, prepareFormInitial, prepareTariffAfterLoad, prepareTariffForSave } from './tariff.config';

let _mounted;
let actions = {};

/**
 * tariff card
 * @returns
 */
export const TariffCard = () => {
  const { t } = useTranslation();

  const dispatch = useDispatch();

  const location = useLocation();
  const history = useHistory();
  const search = new URLSearchParams(location.search);
  // let id = search.get('id');
  const [id, setId] = useState(search.get('id'));
  // let afterAdd = search.get('add');
  const zones = data.getDefaultZones();

  const [tarifficatorType, setTarifficatorType] = useState('');
  const [zone, setZone] = useState(Object.keys(zones)[0]);
  const [fieldsDisable, setFieldsDisable] = useState(true);
  const [showEditWarning, setShowEditWarning] = useState(false);
  const [showSaveWarning, setShowSaveWarning] = useState(false);
  const [showStatusWarning, setShowStatusWarning] = useState(false);
  const [template, setTemplate] = useState('');
  const [templates, setTemplates] = useState([]);
  const [defaultVals, setDefaultVals] = useState(undefined);
  const [tariff, setTariff] = useState(undefined);

  useEffect(() => {
    const search = new URLSearchParams(location.search);
    const newId = search.get('id');
    // console.log('newId', newId);
    setFieldsDisable(true);
    setId(newId);
    // afterAdd = search.get('add');
  }, [location.search]);

  /**
   * prepare initial data
   */
  useEffect(() => {
    _mounted = true;

    // get tariff data
    const getData = async () => {
      let err = false;

      // get tarifficators
      let templates = await getTariffTemplates().catch(() => {
        err = true;
      });
      if (err) {
        templates = [];
      }

      // get tariff
      const tariffOiriginal = await getTariff(id).catch((errors) => {
        err = true;
      });

      // init
      if (!err) {
        const tariff = prepareTariffAfterLoad(tariffOiriginal);
        let def = templates.filter((el) => {
          return el.path === tariff.tarifficator_cls;
        });
        if (!def.length) {
          def = templates.length ? [templates[0]] : [{}];
        }
        if (_mounted) {
          setTariff(tariff);
          setTemplates(templates);
          setTemplate(def[0]);
          setTimeout(() => setDefaultVals(prepareInitial(tariff)), 0);
          setTarifficatorType(getTarifficatorType(tariff));
        }
      }
    };

    // get data from api
    getData();

    return () => {
      _mounted = false;
      // dispatch(removeZoneInfo());
    };
  }, [id]);

  /**
   * get initial data for form
   * @param {*} store
   * @returns
   */
  const prepareInitial = (tariff) => {
    const type = getTarifficatorType(tariff);
    setTarifficatorType(type);
    return prepareFormInitial(tariff, type);
  };

  /**
   * get tarifficator Type
   * @param {*} template
   * @returns
   */
  const getTarifficatorType = (tariff) => {
    return getTarrificatorByPath(tariff.tarifficator_cls, tariff.template);
  };

  /**
   * get displyaed type
   * @param {*} tariffType
   * @returns
   */
  const getDisplayedType = (tariffType) => {
    try {
      let type = tariffTypes.find((elem) => {
        return elem.id === tariffType;
      });
      return type.name;
    } catch (error) {
      return '';
    }
  };

  const getStartTime = (time) => {
    if (time) {
      return moment(time).format('ll');
    }
  };

  /**
   * save tariff
   * @param {*} values
   * @returns
   */
  const update = (values) => {
    // switch off warning
    setShowSaveWarning(false);

    // prepare for save
    const out = prepareTariffForSave(values, tarifficatorType);

    out.tarifficator_cls = template?.path;
    out.tarifficator = template?.template;

    // delete unnecessary
    delete out.data;

    // test
    const test = false;
    if (test) {
      console.log('🚀 ~ update tariff:', out);
      return Promise.resolve(true);
    }

    return updateTariff(id, out)
      .then((data) => {
        // console.log("data", data);
        // setState({
        //   fieldsDisable: true,
        //   showEditWarning: false,
        //   showStatusWarning: false,
        // });
        // showMessageUpdate();
        // history.push(`${path('tariff')}?id=${data.id}`, { time: new Date() });
        notify(t('messages.ВНИМАНИЕ!'), t('messages.Изменения сохранены'), 'success');
        history.push(`${path('tariff')}?id=${data.id}&add=1`);
        // window.location = `${path('tariff')}?id=${data.id}&add=1`;
        // history.go(0)
      })
      .catch((error) => {
        const errors = error.data;
        const out = {};
        if (Array.isArray(errors)) {
          errors.forEach((element) => {
            out[element.field] = element.type;
            out._error = element.type;
          });
        } else {
          out[errors.field] = errors.type;
          out._error = errors.type;
        }

        throw new SubmissionError({ ...out });
      });
  };

  /**
   * close tariff card
   */
  const closeCard = () => {
    history.push(path('tariffs'));
  };

  // close on escape
  useEscape({ action: closeCard });

  /**
   * get transport class
   * @param {*} fullList
   * @param {*} valuesList
   * @returns
   */
  const getTransportClasses = (fullList, valuesList) => {
    if (Array.isArray(fullList) && Array.isArray(valuesList)) {
      let displayedSting = '';

      fullList.forEach((fullListValue) => {
        valuesList.forEach((value) => {
          if (fullListValue.id === value) {
            if (displayedSting) {
              displayedSting += `, ${fullListValue.name}`;
            } else {
              displayedSting += fullListValue.name;
            }
          }
        });
      });
      return displayedSting;
    }
  };

  /**
   * get status message
   * @returns
   */
  const getStatus = () => {
    const { status, time_to } = tariff;

    if (status === 'archive') {
      if (time_to) {
        return `${t('messages.Тариф в архиве с')} ${moment(time_to).format('lll')}`;
      } else {
        return t('messages.Тариф в архиве');
      }
    } else if (status === 'active') {
      return t('messages.Активный тариф');
    }
  };

  /**
   * archive tariff
   */
  const doArchiveTariff = () => {
    archiveTariff(id)
      .then((data) => {
        setTariff(prepareTariffAfterLoad(data));
      })
      .finally(() => {
        setShowStatusWarning(false);
      });
  };

  /**
   * create archive based on current
   */
  const createTariffFromCurrent = () => {
    setShowEditWarning(true);
  };

  /**
   * change tarifficator
   * @param {*} path
   */
  const changeTarifficator = (path) => {
    const template = templates.find((el) => el.path === path);
    // console.log("🚀 ~ changeTarifficator ~ template:", path, template)
    setTemplate(template);

    setZone(Object.keys(zones)[0]);
    const data = cloneDeep(tariff.data);
    data.template = template.template;
    data.zones = cloneDeep(template.data.zones);
    const newDef = cloneDeep(tariff);
    newDef.zones = cloneDeep(data.zones);
    newDef.template = template.template;
    newDef.tarifficator = template.name;
    newDef.tarifficator_cls = template.path;
    newDef.data = data;
    setTariff(newDef);
    // console.log('🚀 ~ changeTarifficator ~ newDef:', newDef);
    setDefaultVals(prepareInitial(newDef));
  };

  // render
  //////////////
  if (!tariff || !defaultVals || !tarifficatorType) {
    return null;
  }

  const categories = getCategories();
  const vehicleClasses = getVehicleClasses();

  const isIndividual = tariff.type === 'individual';
  const infoOk = cloneDeep(tariff);
  const initialOk = cloneDeep(defaultVals);
  const oldTimeFrom = initialOk.time_from;

  if (infoOk.data !== undefined) {
    dataFields.forEach((fn) => {
      if (infoOk.data[fn] !== undefined) {
        infoOk[fn] = infoOk.data[fn];
      }
    });
  }

  // change start time for current
  if (!fieldsDisable) {
    initialOk.time_from = moment().toISOString();
    infoOk.time_from = initialOk.time_from;
  }
  // console.log("infoOk", infoOk.time_from);

  const tarrificatorParams = {
    selectedZone: zone,
    setZone,
    zones: infoOk.zones,
    disabled: fieldsDisable,
    template: defaultVals,
    info: infoOk,
    tarifficatorType,
  };

  const showNewTariffButton = fieldsDisable && !(infoOk.type !== 'individual' && infoOk.status === 'archive') && user.haveRight('tariff.update');
  const getActions = ({ reset }) => {
    actions.reset = reset;
  };

  // console.log('initialOk', initialOk);
  const tableParams = getTableParams(true, t, categories, vehicleClasses);

  return (
    <PageWrapper key={id}>
      <Headline style={{ marginBottom: '20px' }}>
        <p>{t('form.Карточка тарифа')}</p>
        <CloseCardButton close={closeCard} />
      </Headline>

      <>
        {/* table row */}
        <TableExt rows={{ count: 1, items: [infoOk] }} {...tableParams} />
        {/* <StyledTariffsGrid hideTotal vehicleClasses={vehicleClasses} categories={categories} entries={[infoOk]} /> */}

        <Card className="mt20">
          <TariffGeneralInfo>
            <HeaderBlock align={'flex-start'}>
              <NameTarifficator>
                <Name>{infoOk.name}</Name>

                {!fieldsDisable && <TarifficatorSelector onChange={changeTarifficator} items={templates} value={template} />}
              </NameTarifficator>
              <TransportClass>{getTransportClasses(vehicleClasses, infoOk.vehicle_class)}</TransportClass>
              <OtherInfo>
                <span>{getDisplayedType(infoOk.type)}</span>
                <span>{getStartTime(infoOk.time_from)}</span>
              </OtherInfo>
            </HeaderBlock>
            <HeaderBlock align={'flex-end'}>
              <StatusBlock>
                {fieldsDisable && isIndividual && infoOk.status === 'active' && user.haveRight('tariff.update') && (
                  <Button onClick={() => setShowStatusWarning(true)} style={{ marginRight: '1rem' }}>
                    <img src="/images/to-archive-icon.png" alt="" />
                    {t('buttons.В архив')}
                  </Button>
                )}
                {fieldsDisable && <Status status={infoOk.status}>{getStatus()}</Status>}
              </StatusBlock>
              {showNewTariffButton && (
                <Button theme={themes.blue} onClick={() => createTariffFromCurrent()}>
                  {t('buttons.Создать новый на основе данного')}
                </Button>
              )}
            </HeaderBlock>
          </TariffGeneralInfo>

          <DataWrapper>
            <TariffManageWrapper>
              <TariffForm
                oldTimeFrom={oldTimeFrom}
                newTimeFrom={initialOk.time_from}
                onSubmit={update}
                onSubmitClick={() => setShowSaveWarning(true)}
                initialValues={initialOk}
                categories={categories}
                vehicleClasses={vehicleClasses}
                disabled={fieldsDisable}
                info={infoOk}
                tarrificatorParams={tarrificatorParams}
                // showUpdateMessage={showUpdateMessage}
                // showMessageAfterAdd={showAddMessage}
                getActions={getActions}
              />
            </TariffManageWrapper>
          </DataWrapper>
        </Card>
      </>

      {showEditWarning && (
        <Confirm
          width={'480px'}
          title={t('messages.После сохранения нового тарифа, активный тариф автоматически прекратит действие')}
          info={t('messages.Создать новый тариф?')}
          type="danger"
          cancelButton={{
            text: t('buttons.Отменить'),
            func: () => {
              setShowEditWarning(false);
            },
          }}
          acceptButton={{
            text: t('buttons.Создать'),
            func: () => {
              setShowEditWarning(false);
              setFieldsDisable(false);
            },
            theme: themes.blue,
          }}
        />
      )}

      {showSaveWarning && (
        <Confirm
          width={'480px'}
          title={t('messages.Новый тариф автоматически прекратит действие активного')}
          info={t('messages.Сохранить новый тариф?')}
          type="danger"
          cancelButton={{
            text: t('buttons.Отменить'),
            func: () => {
              setShowSaveWarning(false);
            },
          }}
          acceptButton={{
            text: t('buttons.Сохранить'),
            func: () => {
              dispatch(submit('TariffForm'));
            },
            theme: themes.blue,
          }}
        />
      )}

      {showStatusWarning && (
        <Confirm
          width={'480px'}
          title={t('messages.Данный тариф прекратит действие')}
          info={t('messages.Отправить тариф в архив?')}
          type="danger"
          cancelButton={{
            text: t('buttons.Отменить'),
            func: () => {
              setShowStatusWarning(false);
            },
          }}
          acceptButton={{
            text: t('buttons.В архив'),
            func: doArchiveTariff,
            theme: themes.blue,
          }}
        />
      )}
    </PageWrapper>
  );
};
